import React from "react";
import { Result, AutoCenter, Image } from 'antd-mobile';
import { useParams } from "react-router-dom";
import BottomNavLayout from "../../../../components/BottomNavLayout";
import PubHeader from "../../../../components/PubHeader";
import "./style.less";

const PayOrderResult = () => {
  const params = useParams()
  const { orderResult } = params

  const qrcodeImage = 'https://cdz-public.oss-cn-hangzhou.aliyuncs.com/assets/images/qrcode.jpg'

  let title = ''
  if (orderResult === 'payed') {
    title = '订单支付成功'
  } else if (orderResult === 'cancelled') {
    title = '订单已取消'
  } else if (orderResult === 'autocancelled') {
    title = '订单已自动取消'
  } else {
    title = '未知支付结果'
  }

  return (
    <BottomNavLayout>
      <PubHeader title={title} backToHome={true} />

      <div className="order-result">
        {
          orderResult === 'payed' ?
            <Result
              status='success'
              title='订单支付成功'
            />
            :
            undefined
        }

        {
          orderResult === 'cancelled' ?
            <Result
              status='warning'
              title='订单已取消'
            />
            :
            undefined
        }

        {
          orderResult === 'autocancelled' ?
            <Result
              status='warning'
              title='订单已自动取消'
            />
            :
            undefined
        }

        {
          orderResult !== 'payed' && orderResult !== 'cancelled' && orderResult !== 'autocancelled' ?
            <Result
              status='error'
              title='未知支付结果'
            />
            :
            undefined
        }
      </div>

      <div className="qrcode-to-scan">
        <AutoCenter>
          <AutoCenter>
            <span>关注公众号，接收充电通知</span>
          </AutoCenter>
          <Image src={qrcodeImage} ></Image>
        </AutoCenter>
      </div>
    </BottomNavLayout>
  )
}

export default PayOrderResult;